<template>
  <el-date-picker
    class="w-100"
    :modelValue="modelValue"
    @update:modelValue="update($event)"
    type="datetime"
    :size="size"
    :format="format"
    :disabled="disabled"
    :disabledDate="disabledDate"
    :popper-class="popperClass"
    v-if="isEdit"
    :editable="false"
  />
  <jr-input-view v-else :size="size">
    <date-display type="datetime" :date="modelValue" :size="size" />
  </jr-input-view>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'
import DateDisplay from '@/components/displays/DateDisplay.vue'
import { datetimeToStringFormatSlash } from '@/services/date'

export default defineComponent({
  name: 'JrDateTimePicker',
  emits: ['update:modelValue'],
  components: {
    JrInputView,
    DateDisplay,
  },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    format: {
      type: String,
      required: false,
      default: 'YYYY年MM月DD日 HH時mm分ss秒',
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabledDate: {
      type: Function,
      required: false,
      default: null,
    },
    // 「現在」ボタンの表示
    canChangeNow: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    const popperClass = computed(() => {
      // 「現在」ボタン押下不可の場合はクラス付与。_design.scssで指定したCSSでdisplay:noneする
      // 現在ボタンを消すpropが無いためCSSで削除している
      const noChangeNowClass = props.canChangeNow ? '' : 'no-change-now'
      return `jr-datetime-picker-popper ${noChangeNowClass}`
    })

    return {
      popperClass,
      update: (inputDate: Date | null) => {
        if (inputDate == null) {
          context.emit('update:modelValue', null)
          return
        }
        // YYYY/MM/DD HH:mm:ss形式に変換しemit
        context.emit('update:modelValue', datetimeToStringFormatSlash(inputDate))
      },
    }
  },
})
</script>
